export const env = {
  REACT_APP_EXTENSION_IDENTIFIER: process.env.REACT_APP_EXTENSION_IDENTIFIER,
  REACT_APP_ADMIN_SERVER_URL: process.env.REACT_APP_ADMIN_SERVER_URL,
};

export const checkENVVariable = () => {
  const requiredVars = Object.keys(env);
  const missingVars = requiredVars.filter((envVar) => !process.env[envVar]);

  if (missingVars?.length > 0) {
    throw new Error(
      `Missing required env variables: ${missingVars.join(", ")}`
    );
  }
};
